module.exports = __webpack_public_path__ + "static/media/slide-5.a3413bac.jpg";